import { createContext } from 'react';
export var AppState;
(function (AppState) {
    AppState[AppState["START"] = 0] = "START";
    AppState[AppState["READY"] = 1] = "READY";
    AppState[AppState["ERROR"] = 2] = "ERROR";
})(AppState || (AppState = {}));
export var UserContext = createContext({
    user: undefined,
});
export var AppStateContext = createContext({
    appState: AppState.START,
    errorMsg: '',
    onLoginSuccess: function (user) {
        console.log('onLoginSuccess');
    },
    onLoginError: function () {
        console.log('onLoginError');
    },
    onBindMobileSuccess: function (user) {
        console.log('onBindMobileSuccess');
    },
    onBindMobileError: function () {
        console.log('onBindMobileError');
    },
});
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/context.js
// module id = 477
// module chunks = 0